import styled from 'styled-components';

import { Card } from '../../../../common/Styles';

export const ImgWrap = styled.div`
	position: absolute;
	bottom: 25px;
	left: 30px;
`;

export const CardWrap = styled(Card)`
	padding-bottom: 90px;
`;
